import type { StoreState } from '../../storeState';
import { appManager, AppState } from '../manager';
import type {
  InspectUserAssessmentSession,
  InspectUserKlass,
  InspectUserTrainee,
} from './types';

export const selectInspectUserState = (state: StoreState) =>
  state.app.inspect_user;

export const fetchInspectUserKlasses = appManager.createApi<
  Record<string, never>,
  InspectUserKlass[],
  AppState
>('FETCH_INSPECT_USER_KLASSES', {
  path: '/inspect_user/klasses',
  method: 'GET',
  startReducer(state) {
    state.inspect_user.klassesFetching = true;
    state.inspect_user.klassesError = undefined;
  },
  successReducer(state, result) {
    state.inspect_user.klasses = result;
    state.inspect_user.klassesFetching = false;
    state.inspect_user.klassesFetched = true;
  },
  failReducer(state, error) {
    state.inspect_user.klassesFetching = false;
    state.inspect_user.klassesError = error.toString();
  },
});

export const fetchInspectUserUsers = appManager.createApi<
  { klass_id: number },
  InspectUserTrainee[],
  AppState
>('FETCH_INSPECT_USER_USERS', {
  path: '/inspect_user/users',
  method: 'GET',
  startReducer(state, payload) {
    state.inspect_user.usersFetching = true;
    state.inspect_user.usersError = undefined;
    state.inspect_user.usersKlassId = payload.klass_id;
  },
  successReducer(state, result, payload) {
    if (state.inspect_user.usersKlassId !== payload.klass_id) return;
    state.inspect_user.users = result;
    state.inspect_user.usersFetching = false;
  },
  failReducer(state, error, payload) {
    if (state.inspect_user.usersKlassId !== payload.klass_id) return;
    state.inspect_user.usersFetching = false;
    state.inspect_user.usersError = error.toString();
  },
});

export const fetchInspectUserAssessmentSessions = appManager.createApi<
  { user_id: number },
  InspectUserAssessmentSession[],
  AppState
>('FETCH_INSPECT_USER_ASSESSMENT_SESSIONS', {
  path: '/inspect_user/assessment_sessions',
  method: 'GET',
  startReducer(state, payload) {
    state.inspect_user.assessmentSessionsFetching = true;
    state.inspect_user.assessmentSessionsError = undefined;
    state.inspect_user.assessmentSessionsUserId = payload.user_id;
  },
  successReducer(state, result, payload) {
    if (state.inspect_user.assessmentSessionsUserId !== payload.user_id) return;
    state.inspect_user.assessmentSessions = result;
    state.inspect_user.assessmentSessionsFetching = false;
  },
  failReducer(state, error, payload) {
    if (state.inspect_user.assessmentSessionsUserId !== payload.user_id) return;
    state.inspect_user.assessmentSessionsFetching = false;
    state.inspect_user.assessmentSessionsError = error.toString();
  },
});

export const selectInspectUserKlass = appManager.createLocalEvent(
  'SELECT_INSPECT_USER_KLASS',
  (state: AppState, klassId?: number) => {
    state.inspect_user.selectedKlassId = klassId;
    state.inspect_user.users = [];
    state.inspect_user.usersFetching = false;
    state.inspect_user.usersKlassId = undefined;
    state.inspect_user.usersError = undefined;
    state.inspect_user.selectedUserId = undefined;
    state.inspect_user.assessmentSessions = [];
    state.inspect_user.assessmentSessionsFetching = false;
    state.inspect_user.assessmentSessionsUserId = undefined;
    state.inspect_user.assessmentSessionsError = undefined;
  },
);

export const selectInspectUser = appManager.createLocalEvent(
  'SELECT_INSPECT_USER',
  (state: AppState, userId?: number) => {
    state.inspect_user.selectedUserId = userId;
    state.inspect_user.assessmentSessions = [];
    state.inspect_user.assessmentSessionsFetching = false;
    state.inspect_user.assessmentSessionsUserId = undefined;
    state.inspect_user.assessmentSessionsError = undefined;
  },
);
